import { render, staticRenderFns } from "./commuStoryDet.vue?vue&type=template&id=3d0d9558"
import script from "./commuStoryDet.vue?vue&type=script&lang=js"
export * from "./commuStoryDet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports